import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { CollectionContext } from "../currentCollectionContext";

export default function useCollectionBySlug(slug) {
  const { platformData } = useSelector(state => state.frontend);
  const { collection, setCollection, pageStatus, setPageStatus } = useContext(CollectionContext);

  useEffect(() => {
    const shouldUnsetCollection =
      String(slug).toLowerCase() !== String(collection.slug).toLowerCase();
    if (shouldUnsetCollection) setCollection({});
  }, [collection.slug, setCollection, slug]);

  useEffect(() => {
    const isOnDifferentCollectionPage =
      String(slug).toLowerCase() !== String(collection.slug).toLowerCase();
    const shouldReloadCollection = platformData?.id && !!slug && isOnDifferentCollectionPage;
    if (!shouldReloadCollection) return;

    axios
      .get(`/api/collection-by-slug/${slug}/${platformData.id}`)
      .then(resp => {
        setCollection(resp.data || {});
        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .catch(error => {
        if (error.response.status === 404) setPageStatus(404);
        else console.error(error);
      });
  }, [collection.slug, platformData, setCollection, setPageStatus, slug]);

  return { collection, pageStatus };
}
